import { createApi } from "@reduxjs/toolkit/query/react";
import { buildBaseQuery } from "@app/api";
import { FilterParams } from "types";

import { IProduct } from "../types/index";

export const productApi = createApi({
  reducerPath: "productApi",
  baseQuery: buildBaseQuery(""),
  endpoints: (builder) => ({
    getProducts: builder.query<{ products: IProduct[]; count: number}, FilterParams>({
      query: (params) => {
        const queryString = Object.entries(params)
          .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
          .join('&');

        return `/products/dashboard?${queryString}`;
      },
    }),
    getProductById: builder.query<IProduct, string>({
      query: (productId) => `/products/${productId}`,
    }),
    createProduct: builder.mutation<void, FormData>({
      query: (body) => ({
        url: "/products",
        method: "POST",
        body,
      }),
    }),
    updateProduct: builder.mutation<void, any>({
      query: ({ id, formData }) => ({
        url: `/products/${id}`,
        method: "PATCH",
        body: formData,
      }),
    }),
    deleteProduct: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `/products/${id}`,
        method: "DELETE",
      }),
    }),
    reorderProducts: builder.mutation<void, any>({
      query: (body) => ({
        url: `/products/reorder`,
        method: "PATCH",
        body: {
          orders: body
        }
      }),
    }),
  }),
});

export const {
  useGetProductsQuery,
  useLazyGetProductsQuery,
  useDeleteProductMutation,
  useCreateProductMutation,
  useUpdateProductMutation,
  useLazyGetProductByIdQuery,
  useReorderProductsMutation
} = productApi;
